module.exports = __webpack_public_path__ + "img/video03.f9fb0736.jpg";